// @ts-check
import classNames from 'classnames';
import { graphql } from 'gatsby';
import React from 'react';
import GatsbyBackgroundImage from './images/GatsbyBackgroundImage';

import './ExpandableContentBlock.scss';

export const query = graphql`
	fragment ExpandableCoverFragment on Ozk_content_block {
		expandable_cover {
			heading
			copy
			expand_text
			background_image {
				...BynderImageFragment
			}
		}
	}
`;

/**
 * @typedef ExpandableContentBlockModel
 * @property {string} heading
 * @property {string} copy
 * @property {string} expand_text
 * @property {import('../CSTypes').BynderImageOptions[]} background_image

 * @typedef ExpandableContentBlockProps
 * @property {ExpandableContentBlockModel} options
 */
/** @type {import('~/types/React').ReactFC<ExpandableContentBlockProps>} */
const ExpandableContentBlock = ({ options: { background_image, copy, expand_text, heading }, children, ...rest }) => {
	const [isOpen, setIsOpen] = React.useState(false);
	const toggle = () => setIsOpen((prev) => !prev);

	// Short circuit if all of the props are not provided.
	if (!heading || !copy || !expand_text || !background_image?.[0]) {
		return <>{children}</>;
	}

	return (
		<div {...rest} className={classNames('expandable-content-block container', rest.className, { expanded: isOpen })}>
			<GatsbyBackgroundImage className="expandable-content-block-cover" option={background_image?.[0]}>
				{/* Cover Content */}
				<div className="expandable-content-opacity-background" onClick={toggle}>
					<h1>{heading}</h1>
					<p>{copy}</p>
					<div className="expandable-content-block-button-text">{expand_text}</div>
				</div>
			</GatsbyBackgroundImage>
			{/* The expanded content. */}
			<div className={classNames('expandable-content-block-bottom', isOpen ? 'block' : 'none')}>{children}</div>
		</div>
	);
};

export default ExpandableContentBlock;
